module.exports = __webpack_public_path__ + "static/media/Bell_beaker_eba_wales_text_01.f65101e2.jpg";